/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 11:26:56
 * @LastEditTime: 2020-11-25 15:17:04
 */
// ====event 事件相关
import { isFunction } from './base';
var is_Ready = false; // 私有函数

function bindReadyEvent() {
  if (document.readyState === 'complete') {
    return ready();
  }

  if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', function fc() {
      document.removeEventListener('DOMContentLoaded', fc, false);
      ready();
    }, false);
    window.addEventListener('load', ready, false);
  } else if (document.attachEvent) {
    document.attachEvent('onreadystatechange', function fc() {
      if (document.readyState === 'complete') {
        document.detachEvent('onreadystatechange', fc);
        ready();
      }
    });
    window.attachEvent('onload', ready);

    if (document.documentElement.doScroll && window == window.top) {
      if (is_Ready) return;

      try {
        document.documentElement.doScroll('left');
      } catch (e) {
        setTimeout(bindReadyEvent, 0);
        return;
      }

      ready();
    }
  }
}

function ready() {
  if (!is_Ready) {
    if (!document.body) {
      return setTimeout(ready, 13);
    }

    is_Ready = true;

    if (event.readyFn.length > 0) {
      var i = 0;
      var fn; // eslint-disable-next-line no-plusplus

      while (fn = event.readyFn[i++]) {
        fn.call();
      }

      event.readyFn.length = 0;
    }
  }
}

var event = {
  /**
     * 停止事件继续进行
     * @param {event} e 事件
     * @return {dom}
     */
  preventDefault: function preventDefault(e) {
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      e.returnValue = false;
    }
  },

  /**
     * 阻止事件冒泡传递
     * @param {event} e 事件
     * @return {dom}
     */
  stopPropagation: function stopPropagation(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      e.cancelBubble = true;
    }
  },

  /**
     * 为DOM对象增加事件
     * @param {dom} element dom对象
     * @param {string} type 事件名称
     * @param {function} type 事件方法
     * @return {undefined}
     */
  addEvent: function addEvent(el, type, fn) {
    var self = this;

    if (window.addEventListener) {
      el["e".concat(type).concat(fn)] = fn;

      el[type + fn] = function (e) {
        var _e = e || window.event;

        var _r = el["e".concat(type).concat(fn)](_e);

        if (_r == false) {
          self.preventDefault(_e);
          self.stopPropagation(_e);
        }
      };

      el.addEventListener(type, el[type + fn], false);
    } else if (window.attachEvent) {
      el["e".concat(type).concat(fn)] = fn;

      el[type + fn] = function () {
        var _r = el["e".concat(type).concat(fn)](window.event);

        if (_r == false) self.preventDefault(window.event);
      };

      el.attachEvent("on".concat(type), el[type + fn]);
      return;
    } else {
      el["on".concat(type)] = fn;
    }
  },

  /**
     * 为DOM对象移除事件
     * @param {dom} element dom对象
     * @param {string} type 事件名称
     * @param {function} type 事件方法
     * @return {undefined}
     */
  removeEvent: function removeEvent(_el, _type, _fn) {
    // 解绑单个事件
    var removeSingle = function removeSingle(el, type, fn) {
      if (window.removeEventListener) {
        el.removeEventListener(type, el[type + fn], false);
        el[type + fn] = null;
      } else if (window.detachEvent) {
        el.detachEvent("on".concat(type), el[type + fn]);
        el[type + fn] = null;
        return;
      } else {
        el["on".concat(type)] = null;
      }
    }; // 需要解绑所有_type类型的事件


    if ('undefined' === typeof _fn) {
      for (var k in _el) {
        if (0 == k.indexOf(_type) && 'function' === typeof _el[k]) {
          removeSingle(_el, _type, k.substring(_type.length));
        }
      }
    } else {
      // 解绑单个事件
      removeSingle(_el, _type, _fn);
    }
  },

  /* isReady : false,*/
  readyFn: [],

  /**
     * dom ready事件
     * @param {dom} element dom对象
     * @param {string} type 事件名称
     * @param {function} type 事件方法
     * @return {undefined}
     */
  ready: function ready(fn) {
    bindReadyEvent();

    if (is_Ready) {
      fn.call();
    } else {
      if (isFunction(fn)) {
        this.readyFn.push(fn);
      }
    }
  }
};
export default event;